import { render, staticRenderFns } from "./mDialog.vue?vue&type=template&id=1c3617e2&scoped=true&"
import script from "./mDialog.vue?vue&type=script&lang=js&"
export * from "./mDialog.vue?vue&type=script&lang=js&"
import style0 from "./mDialog.vue?vue&type=style&index=0&id=1c3617e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3617e2",
  null
  
)

export default component.exports